import { DomainReference } from '@rygen/rygen-ui/model';

import { ProposedShipment } from './ProposedShipment';

export class RouteBuilderRequest {
  proposedShipments: ProposedShipment[] = [];
  owner?: DomainReference;
  skipAutoAction = false;

  constructor(opts?: Partial<RouteBuilderRequest>) {
    if (opts?.proposedShipments != null) {
      this.proposedShipments = opts.proposedShipments.map(
        (s) => new ProposedShipment(s),
      );
    }

    if (opts?.owner != null) {
      this.owner = new DomainReference(opts.owner);
    }

    if (opts?.skipAutoAction != null) {
      this.skipAutoAction = opts.skipAutoAction;
    }
  }

  // The getters below aren't intended for real usage. They're here to make
  // this class match the shape of other `ParentEntity` types.
  get id() {
    return undefined;
  }

  get origin() {
    return undefined;
  }

  get destination() {
    return undefined;
  }

  get stops() {
    return this.proposedShipments.map((s) => s.stops).flat();
  }

  get requestedAccessorials() {
    return [];
  }
  // End pointless getters
}
